<asg-floating-menu [menuItem]="AsgardFeatureNames.HIGHLIGHT_MENU">
  <ul>
    <li [ngClass]="{ 'active-menu-item': modeActive === DocumentMarkersMode.Eraser }" (click)="eraserClicked()" asgTooltip="TOOLBARS.ERASER">
      <i class="fas fa-eraser"></i>
    </li>
    @for (color of supportedColors; track color) {
      <li
        [ngClass]="{
          'active-menu-item':
            modeActive === DocumentMarkersMode.Marker &&
            activeColor.hex === color.hex
        }"
        (click)="colorChosen(color)"
        asgTooltip="TOOLBARS.HIGHLIGHTER"
        >
        <i class="fas fa-highlighter" [style.color]="color.actualColor"></i>
      </li>
    }
    <li (click)="extract(); floatingMenu.close()" asgTooltip="TOOLBARS.EXTRACT_HIGLIGHTINGS">
      <i class="fas fa-external-link-alt"></i>
    </li>
  </ul>
</asg-floating-menu>
